import { render, staticRenderFns } from "./travelerList.vue?vue&type=template&id=2f9c2e56&scoped=true&"
import script from "./travelerList.vue?vue&type=script&lang=js&"
export * from "./travelerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c2e56",
  null
  
)

export default component.exports